export function isImage(filename) {
	if(!filename) return false;
	switch (filename.toLowerCase()) {
		case "jpg":
		case "jpeg":
		case "png":
			return true;
	}
	return false;
}
export function isVideo(filename) {
	if(!filename) return false;
	return filename.toLowerCase() === "mp4";
}

export function isAudio(filename) {
	if(!filename) return false;
	switch (filename.toLowerCase()) {
		case "wav":
		case "mp3":
			return true;
	}
	return false;
}
export function isExcel(extension) {
	switch (extension.toLowerCase()) {
		case "xls":
		case "xlsx":
			return true;
	}
	return false;
}
